import { makeAutoObservable } from 'mobx'
import * as API from '../../service/api/ContentManageApi'
import table from '../commons/table'

class ContentStore {
  constructor() {
    makeAutoObservable(this)
  }

  table = new table(API.GET_CONTENT_LIST)

  init = (param, pageNo, pageSize) => {
    this.table.init(param)
    this.table.getList(pageNo, pageSize)
  }

  addContentName = async (data) => {
    return await API.ADD_CONTENT_NAME(data)
  }

  getContentDetail = async (id) => {
    return await API.GET_CONTENT_DETAIL(id)
  }

  delContent = async (data) => {
    return await API.DEL_CONTENT(data)
  }

  updateContent = async (data) => {
    return await API.UPDATE_CONTENT_INFO(data)
  }
}

export default new ContentStore()
